import React, { useCallback, useState } from "react";
import { Portal, Snackbar, Slide, Alert } from '@mui/material';

export const withSnackbar = WrappedComponent => {
  return props => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [duration, setDuration] = useState(2000);
    const [vertical, setVertical] = useState("bottom");
    const [horizontal, setHorizontal] = useState("center");
    const [severity, setSeverity] = useState(
      "success"
    );

    // Stable identity: components list snackbarShowMessage in effect deps, and a new
    // function on every render made those effects re-run (and reload data) after each message.
    const showMessage = useCallback((message, severity = "success", duration = 2000, vertical = 'bottom', horizontal= 'center') => {
      setMessage(message);
      setSeverity(severity);
      setDuration(duration);
      setOpen(true);
      setVertical(vertical);
      setHorizontal(horizontal);
    }, []);

    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpen(false);
    };

    return (
      <>
        <WrappedComponent {...props} snackbarShowMessage={showMessage} />
        <Portal>
          <Snackbar
            anchorOrigin={{
                vertical,
                horizontal
            }}
            autoHideDuration={duration}
            open={open}
            onClose={handleClose}
            TransitionComponent={Slide}
            sx={{
              position: "fixed",
              bottom: 0,
              zIndex: 10000,
            }}
          >
            <Alert variant="filled" severity={severity}>
              {message}
            </Alert>
          </Snackbar>
        </Portal>
      </>
    );
  };
};
